import React, { Component, useEffect, useState } from "react";
import "../../custom-css/custom-style.css";
// import "../../assets/fonts/stylesheet.css";
import dummyImg from "../../../src/assets/images/dummy-img.png";
import ChangePassword from "./changePassword";
import { useNavigate } from "react-router";
import moment from "moment";
import DEVELOPMENT_CONFIG from "../../helper/config";
import ApiUrls from "../../helper/api-urls";
import AppRoutes from "../../helper/app-routes";
import ApiHelper from "../../helper/api-helper";
import { NotificationManager } from "src/util/notify";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch, useSelector } from "react-redux";
import { SELECTED_STAFF_ID } from "../../actions";
import APP_ROUTES from "../../helper/app-routes";
import { useLocation } from "react-router-dom";

const RefreshToken = async () => {
  var refreshtoken = localStorage.getItem("refeshtoken");
  var data = {
    refreshToken: refreshtoken,
  };
  ApiHelper.postRequest(ApiUrls.RERESH_TOKEN, data)
    .then((result) => {
      localStorage.setItem(DEVELOPMENT_CONFIG.TOKEN, result.resultData.token);
      localStorage.setItem(
        DEVELOPMENT_CONFIG.REFRESH_TOKEN,
        result.resultData.refreshToken
      );
      localStorage.setItem(DEVELOPMENT_CONFIG.LOGIN_TIME, moment().format());
      localStorage.setItem(
        DEVELOPMENT_CONFIG.TOKEN_EXPIRETIME,
        moment().add(result.resultData.tokenExpireIn, "seconds").format()
      );
      localStorage.setItem(
        DEVELOPMENT_CONFIG.REFRESHTOKEN_EXPIRETIME,
        moment().add(result.resultData.refreshTokenExpireIn, "seconds").format()
      );
    })
    .catch((error) => {
      NotificationManager.error(error);
      localStorage.clear();
      window.location.href = "/login";
    });
};

function Header({ toggleOpen }) {
  const navigate = useNavigate();
  const location = useLocation();
  const anchor = React.useRef(null);
  const [timer, setTimer] = useState("10:00");
  const [counterpopup, setCounterPopup] = React.useState(false);
  const [isChangePassword, setChangePassword] = React.useState(false);
  const [loginData, setLoginData] = React.useState("");
  const dispatch = useDispatch();
  const [clientData, setClientData] = React.useState([]);
  const [searchValue, setSearchValue] = React.useState("");
  const isGlobalSearchReducer = useSelector(
    (state) => state.isGlobalSearchReducer
  );
  const newPath = location.pathname.toLowerCase();

  let adminDetail = localStorage.getItem("adminDetail");
  let adminName = JSON.parse(adminDetail);
  let d = newPath.split("/");
  let primaryPath = d[1];

  useEffect(() => {
    if (
      location.pathname == APP_ROUTES.GET_CLIENT ||
      primaryPath !== "client"
    ) {
      setSearchValue("");
    }
    const interval = setInterval(() => {
      GetDateDiff(new Date(localStorage.accessTokenExpireTime), new Date());
    }, 10000);
    return () => clearInterval(interval);
  }, [location.pathname]);

  const getDeadTime = (seconds) => {
    let deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + seconds);
    return deadline;
  };
  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    return { minutes, seconds };
  };
  const startTimer = (e) => {
    let { minutes, seconds } = getTimeRemaining(e);
    if (minutes >= 0 && seconds >= 0) {
      setTimer(
        (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds)
      );
    } else {
      localStorage.clear();
      window.location.href = "/login";
    }
  };
  const clearTimer = (e) => {
    setTimer("10:00");
    if (anchor.current) clearInterval(anchor.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    anchor.current = id;
  };

  const logOut = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  function showCounterPopup() {
    setCounterPopup(true);
  }

  function resetSession() {
    setCounterPopup(false);
    clearTimer(getDeadTime(18000));
  }
  function GetDateDiff(startDate, endDate) {
    var mins = parseInt(
      (Math.abs(endDate.getTime() - startDate.getTime()) / (1000 * 60)) % 60
    );
    if (mins < 15) {
      RefreshToken();
    }
  }

  const handleOnIdle = (event) => {
    showCounterPopup(true);
    clearTimer(getDeadTime(600));
  };
  const handleOnActive = (event) => {};
  const handleOnAction = (event) => {};
  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 60,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500,
  });
  const profileHandler = () => {
    dispatch({
      type: SELECTED_STAFF_ID,
      payload: loginData.id,
    });
    navigate(AppRoutes.STAFF_PROFILE);
  };

  const changePassword = () => {
    setChangePassword(true);
  };

  const handleClosePassword = () => {
    setChangePassword(false);
  };

  return (
    <div className="top-header-menu">
      
        <button
          onClick={toggleOpen}
          className="bg-transparent border-0 text-white"
        >
          {" "}
          <i class="fa fa-angle-right mr-2 open-bar" aria-hidden="true"></i>
          {/* <i class="fa fa-angle-left mr-2 close-bar" aria-hidden="true"></i> */}
        </button>
       

      <div className="topbar-items nav-right">
        <ul className="list-unstyled d-flex align-items-center mb-0">
          <li className="dropdown  drop-user-toogle ">
            <a
              className="notification-drop user_profile"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                src={
                  loginData.profileImageId ? loginData.profileImageId : dummyImg
                }
                alt=""
                className="user-top"
              />
              <span>
                  <p class="text-white mb-0 fw-600"> {`${adminName?.firstName} ${adminName?.lastName}`}</p>
               </span>
            </a>
            <div
              className="dropdown-menu dropdown-menu-right py-0 border-0"
              aria-labelledby="dropdownMenuButton"
            >
              <div className="logout-drop">
                {/* <h6 className="user-name ">
                  <a className="dropdown-item  text-capitalize p-0">
                    {`${adminName?.firstName} ${adminName?.lastName}`}
                  </a>
                </h6> */}
             
                <ul className="list-unstyled list-prodile  list_profile_cus">
                  <li>
                    <a
                      className="text-decoration-none f-14 text-theme fw-600"
                      href="#"
                      onClick={profileHandler}
                    >
                      <i class="fa fa-user mr-2" aria-hidden="true"></i>
                      My Profile
                    </a>
                  </li>
                  <hr className="my-2" />
                  <li>
                    <a
                      className="text-decoration-none f-14 my-2 text-theme fw-600"
                      href="#"
                      onClick={logOut}
                    >
                      <i class="fa fa-sign-out mr-2" aria-hidden="true"></i>
                      Logout
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>

      {counterpopup && (
        <Dialog title={"Session Expire Time"} onClose={resetSession}>
          <h5
            style={{
              margin: "25px",
              textAlign: "center",
            }}
          >
            You will get timed out in {timer} minutes. You want to stay?
          </h5>
          <DialogActionsBar>
            <button
              className="common-btn-size k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={resetSession}
            >
              {" "}
              Yes
            </button>
            <button
              className="common-btn-size k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={logOut}
            >
              No
            </button>
          </DialogActionsBar>
        </Dialog>
      )}

      {isChangePassword && <ChangePassword onClose={handleClosePassword} />}
    </div>
  );
}
export default Header;
